
import { Shell } from "@/components/layout/Shell";
import { ServicesTable } from "@/components/services/ServicesTable";

export default function ServicesPage() {
  return (
    <Shell>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Services</h1>
          <p className="text-muted-foreground mt-2">
            Manage your contract services
          </p>
        </div>

        <ServicesTable />
      </div>
    </Shell>
  );
}
